var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Button } from 'shared/components/ui';
import SparkMD5 from 'spark-md5';
export var validateFileIsImage = function (file) {
    var _a;
    var fileType = (_a = file === null || file === void 0 ? void 0 : file.fileType) === null || _a === void 0 ? void 0 : _a.type;
    // if for some reason the image object is not the expected, return validation error
    if (!fileType)
        return 'Please upload a valid image file type';
    return fileType.includes('image/') ? true : 'Please upload a valid image file type';
};
export var FileBrowseButton = function (props) {
    var accept = props.accept, children = props.children, multiple = props.multiple, checksum = props.checksum, onFileLoaded = props.onFileLoaded, buttonProps = __rest(props, ["accept", "children", "multiple", "checksum", "onFileLoaded"]);
    var inputRef = useRef(null);
    var handleOnClick = function () {
        if (!inputRef.current)
            return;
        inputRef.current.click();
    };
    var handleOnChange = function (e) {
        var _a;
        var files = Array.from((_a = e.target.files) !== null && _a !== void 0 ? _a : []);
        e.target.value = ''; // clear out the input so user can choose the same file again
        if (!(files === null || files === void 0 ? void 0 : files.length))
            return;
        files.forEach(function (file) {
            var reader = new FileReader();
            var data;
            var checksumHash;
            var finalizeFileLoad = function () {
                if (data && (!checksum || checksumHash) && onFileLoaded) {
                    onFileLoaded(data, file.name, file, checksumHash);
                }
            };
            reader.onload = function () {
                var result = reader.result;
                if (typeof result === 'string') {
                    data = result;
                }
                finalizeFileLoad();
            };
            reader.readAsDataURL(file);
            if (checksum) {
                var arrayReader_1 = new FileReader();
                arrayReader_1.onload = function () {
                    var result = arrayReader_1.result;
                    if (result instanceof ArrayBuffer) {
                        var spark = new SparkMD5.ArrayBuffer();
                        spark.append(result);
                        checksumHash = spark.end();
                    }
                    finalizeFileLoad();
                };
                arrayReader_1.readAsArrayBuffer(file);
            }
        });
    };
    return (_jsxs(Button, __assign({ onClick: handleOnClick }, buttonProps, { children: [_jsx("input", { type: 'file', multiple: !!multiple, hidden: true, accept: accept, ref: inputRef, onChange: handleOnChange, "data-testid": "fileBrowse" }), children] })));
};
export default FileBrowseButton;
